import MessagingReducer from 'mrshoebox-ui-components/src/modules/Messaging/reducers'

export default MessagingReducer
